import { Link } from "react-router-dom";

export const Footer = ({
    homeLink = "/",
    adhesionLink = "/adhesion",
    contactLink = "/contact"
}) => {
    return (
        <footer className="bg-slate-900 text-slate-300 py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8 mb-8">
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex flex-col items-start gap-2 mb-4">
                            <img src="/assets/logo.png" alt="Hafani Logo" className="h-8 w-auto brightness-200" />
                            <span className="text-xs text-emerald-400 font-medium italic">Hafani, une solution pensée pour notre fin</span>
                        </div>
                        <p className="text-sm text-slate-400 max-w-xs mt-4">
                            Facilitons l'entraide et la solidarité communautaire.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold text-white mb-4">Liens rapides</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to={homeLink} className="hover:text-emerald-400">Accueil</Link></li>
                            <li><Link to={adhesionLink} className="hover:text-emerald-400">Adhésion</Link></li>
                            <li><Link to={contactLink} className="hover:text-emerald-400">Contact</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-semibold text-white mb-4">Légal</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="#" className="hover:text-emerald-400">Mentions légales</Link></li>
                            <li><Link to="#" className="hover:text-emerald-400">Confidentialité</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-slate-800 pt-8 text-center text-xs text-slate-500">
                    &copy; {new Date().getFullYear()} Hafani. Tous droits réservés.
                </div>
            </div>
        </footer>
    );
};
